import { push, ref, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetExpenseDataFirebase from "../../Expense/GetExpenseDataFirebase";

const EditAssignerUserExpenseDataInFirebase = async (state, dispatch, id, expenseData, userID, ownerUid) => {
    if (!ownerUid) return null;



    try {



        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${ownerUid}/expense/${id}`);

        console.log("EditAssignerUserExpenseDataInFirebase -> Payload received:", expenseData);
        const payloadToSave = {
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            companyId: expenseData?.companyId?.toString() || "",
            createdDate: new Date().getTime().toString(),
            amount: expenseData?.amount?.toString() || "",
            expenseCategory: (expenseData?.category || expenseData?.expenseCategory)?.toString() || "",
            expenseDate: expenseData?.expenseDate || new Date().toISOString().slice(0, 10), // Defaults to today
            expenseDescription: (expenseData?.description || expenseData?.expenseDescription)?.toString() || "",
            expenseId: expenseData?.expenseId?.toString() || "",
            paymentMethod: expenseData?.paymentMethod || "Cash",
            expenseName: expenseData?.expenseName || "",
            updateDate: expenseData?.updateDate?.toString() || new Date().getTime().toString(),
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            currency: expenseData?.currency?.toString() || ""
        };
        console.log("EditAssignerUserExpenseDataInFirebase -> Final payload pushed to Firebase:", payloadToSave);

        // Push new invoice data
        await update(userRef, payloadToSave);

        // Fetch updated invoice data
        await GetExpenseDataFirebase(state, dispatch);

        return { success: true, message: "Expense updated successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default EditAssignerUserExpenseDataInFirebase;
